import { configureStore } from "@reduxjs/toolkit";
import loginReducer from "./features/login/loginSlice";
import adsReducer from "./features/sharingAdvertisment/SharingAdSlice";
import userReducer from "./features/user/userSlice";
import countryReducer from "./features/country/countrySlice";
import languageReducer from "./features/language/language";
import tournamentReducer from "./features/tournament/tournamentSlice";
import notificationReducer from "./features/notification/notificationSlice";
import loaderReducer from "./features/loader/loaderSlice";
import gameTypeReducer from "./features/gameType/gameTypeSlice";
import notificationsReducer from "./features/notifications/notificationsSlice";
import chatNotificationsReducer from "./features/chatNotifications/chatNotificationsSlice";
import categoryReducer from './features/category/categorySlice';
import productReducer from "./features/product/productSlice";
import bannerReducer from "./features/banner/bannerSlice";
import cartReducer from "./features/cart/cartSlice";
import gamificationReducer from "./features/gamification/gamificationSlice"

export const store = configureStore({
  reducer: {
    login: loginReducer,
    user: userReducer,
    country: countryReducer,
    language: languageReducer,
    tournament: tournamentReducer,
    notification: notificationReducer,
    loader: loaderReducer,
    gameType: gameTypeReducer,
    notifications: notificationsReducer,
    chatNotifications: chatNotificationsReducer,
    ads: adsReducer,
    category: categoryReducer,
    product: productReducer,
    banner: bannerReducer,
    cart: cartReducer,
    gamification: gamificationReducer,
  },
});
